import React from 'react'
import "./Achievement.css"
import point2 from "../../assets/whitepoint.svg"
import waheedLogo from "../../assets/icons/bg.svg"
import green from "../../assets/greenline.svg"
import starIcon from "../../assets/icons/starIcon.svg"
import smileIcon from "../../assets/icons/smileIcon.svg"
import projectsIcon from "../../assets/icons/projectIcons.svg";
import investmentsIcon from "../../assets/icons/investmentsIcon.svg";
import { useTranslation } from "react-i18next";


export default function Achievement() {
    const { t, i18n } = useTranslation();
  
    return (
      <section id="achievements">
        <div className="achievement-container">
          <h1 className="achievement-title">
            <img src={point2} className="bullet-point" />
            {t("Achievements_and_Numbers")}
            <img src={point2} className="bullet-point" />
          </h1>
          <p className="achievement_p"> {t("achievement_p")}</p>
          <img src={waheedLogo} className="waheed-logo" />
          <img src={green} className="green-line" />

          {/* Achievements Row */}
          <div className="achievements-row">
            <div className="achievement-item">
              <img src={starIcon} />
              <h2>20</h2>
              <h3>{t("experience_year")} </h3>
            </div>
            <p className="vertical-line"></p>

            <div className="achievement-item">
              <img src={smileIcon} />
              <h2>2500</h2>
              <h3> {t("training_hour")}</h3>
            </div>
            <p className="vertical-line"></p>

            <div className="achievement-item">
              <img src={projectsIcon} />
              <h2>421</h2>
              <h3>{t("project")}</h3>
            </div>
            <div className="vertical-line"></div>

            <div className="achievement-item">
              <img src={investmentsIcon} />
              <h2>25</h2>
              <h3>{t("investment")}</h3>
            </div>
          </div>
        </div>
      </section>
    );
  }